// extracted by mini-css-extract-plugin
module.exports = {"PagerContainer":"Pager_PagerContainer__2FWZD","Pager":"Pager_Pager__1C_yX","Disabled":"Pager_Disabled__23QNs"};